// src/components/PdfViewer.js
import BackButton from './BackButton';
import TopTabs from './TopTabs';

const PdfViewer = ({ src }) => {


  return (
    <div>
      <TopTabs />
      <BackButton />

      <div
        style={{
          position: 'fixed',
          top: '5rem',   // 顶部导航高度
          left: 0,
          right: 0,
          bottom: 0,
          overflow: 'hidden',
        }}
      >
        <iframe
          title="PDF Viewer"
          src={src}
          style={{ width: '100%', height: '100%', border: 'none', display: 'block' }}
        />
      </div>
    </div>


  );
};

export default PdfViewer;
